var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            !_vm.isConsolidatedRequest
              ? _c("div", { staticClass: "row justify-content-end mb-2" }, [
                  !_vm.isBankStatementRequest
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "bold text-regular-gray tiny text-uppercase mr-4",
                          },
                          [_vm._v(_vm._s(_vm.$t("global.words.subject")))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "font-sm" }, [
                          _vm._v(_vm._s(_vm.subject)),
                        ]),
                      ])
                    : _c("div", { staticClass: "col-12" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "bold text-regular-gray tiny text-uppercase mr-4",
                          },
                          [_vm._v(_vm._s(_vm.$t("global.words.institution")))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "font-sm" }, [
                          _vm._v(_vm._s(_vm.institution)),
                        ]),
                      ]),
                  _vm._v(" "),
                  !_vm.isBankStatementRequest
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "bold text-regular-gray tiny text-uppercase mr-4",
                          },
                          [_vm._v(_vm._s(_vm.$t("global.words.message")))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "font-sm" }, [
                          _vm._v(_vm._s(_vm.message)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isBankStatementRequest
                    ? _c("div", { staticClass: "col-12" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "bold text-regular-gray tiny text-uppercase mr-4",
                          },
                          [_vm._v(_vm._s(_vm.$t("global.words.status")))]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "font-sm" }, [
                          _c(
                            "span",
                            {
                              staticClass: "ml-1 badge",
                              class: _vm.getBadgeType(_vm.status),
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm._f("removeHyphens")(_vm.status)) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "a",
                            {
                              staticClass:
                                "bold tiny text-uppercase mr-4 clickable text-primary",
                              on: { click: _vm.toggleExpand },
                            },
                            [
                              _vm.expanded
                                ? _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("global.actions.hideDetails")
                                        ) +
                                        "\n              "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-caret-up ml-1",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("global.actions.showDetails")
                                        ) +
                                        "\n              "
                                    ),
                                    _c("i", {
                                      staticClass: "fa fa-caret-down ml-1",
                                      attrs: { "aria-hidden": "true" },
                                    }),
                                  ]),
                            ]
                          ),
                        ]),
                      ])
                    : _c("div", { staticClass: "col-12" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "bold text-regular-gray tiny text-uppercase mr-4",
                          },
                          [_vm._v(_vm._s(_vm.$t("global.words.succeeded")))]
                        ),
                        _vm._v(" "),
                        _c("span", [
                          _c("i", {
                            staticClass: "fa",
                            class: _vm.succeededIcon,
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]),
                      ]),
                ])
              : _c("timeline-consolidated-request", {
                  attrs: { metadata: _vm.metadata },
                }),
            _vm._v(" "),
            _vm.expanded
              ? _c(
                  "div",
                  { staticClass: "row flex-wrap" },
                  _vm._l(_vm.signers, function (signer, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "col-xl-3 col-lg-auto col-md-6 col-12 timeline-signer-item mb-3",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "timeline-signer clickable" },
                          [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                              },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("global.words.status")) + ": "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "ml-0 mb-0 badge",
                                    class: _vm.getBadgeType(signer.status),
                                    staticStyle: { "font-size": "0.5rem" },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(signer.status) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                              },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("client-profile.signerName")
                                    ) + ": "
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(signer.name) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "small text-gray w-100 mb-0 regular-line-height px-2",
                              },
                              [
                                _c("span", { staticClass: "bold" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("capitalize")(
                                        _vm.$tc("global.words.email", 1)
                                      )
                                    ) + ":\n            "
                                  ),
                                ]),
                                _vm._v(
                                  "\n            " +
                                    _vm._s(signer.email) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("timeline-card-footer", {
              attrs: { "show-pin": false },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center mb-md-0 mb-2",
                          attrs: { cols: "12", md: "auto" },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.actionText) + "\n            "),
                            _c("span", { staticClass: "text-secondary" }, [
                              _vm._v(_vm._s(_vm.cardHeader)),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center",
                          attrs: { cols: "12", md: "auto" },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "px-2 d-none d-md-inline" },
                            [_vm._v("-")]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "mr-1" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._f("momentLocal")(
                                    _vm.dateAt,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                " @\n            " +
                                _vm._s(
                                  _vm._f("momentLocal")(_vm.dateAt, "LT")
                                ) +
                                "\n          "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }